"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const getOptionalLinkProperties = (input) => {
  const res = {};
  if ("text" in input) {
    res.text = input.text;
  }
  if ("variant" in input) {
    res.variant = input.variant;
  }
  return res;
};
exports.getOptionalLinkProperties = getOptionalLinkProperties;
//# sourceMappingURL=getOptionalLinkProperties.cjs.map
